import { Input } from "../../../components/Input/input";
import styled from "styled-components";
import * as yup from "yup";
import { useFormik } from "formik";
import { theme } from "../../../helpers/theme";
import { useEffect } from "react";
import { OperatorAddData } from "../../../services/users/add/types";

interface OperatorAddFormProps{
  setOperator: (operator: OperatorAddData) => void;
  setFormValid: (valid: boolean) => void;
}

export const OperatorAddForm = ({setOperator, setFormValid}:OperatorAddFormProps) => {

  const validationSchema = yup.object({
    imie: yup
      .string()
      .required("Pole wymagane"),
    nazwisko: yup
      .string()
      .required("Pole wymagane"),
    email: yup
      .string()
      .email("Niepoprawny adres email")
      .required("Pole wymagane"),
    telefon: yup
      .string()
      .required("Pole wymagane")
      .matches(/^[0-9]+$/, "Niepoprawny numer telefonu")
      
  });
  const formik = useFormik({
    initialValues: {
        imie: "",
        nazwisko: "",
        email: "",
        telefon: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
    },
  });


  useEffect(() => {
    if (formik.values.imie !== "" && formik.values.nazwisko !== "" && formik.values.email !== "" && formik.values.telefon !== "" && formik.values.telefon.length === 9 && formik.isValid ) {
      setOperator(formik.values)
      if (formik.isValid) {
        setFormValid(true)
      }
    }
  }, [formik.values])

  return (
    <BasicFormWrapper onSubmit={formik.handleSubmit}>
      <FormWrapper>
        <Input
          label="Imie"
          id="imie"
          name="imie"
          value={formik.values.imie}
          onChange={formik.handleChange}
          error={formik.touched.imie && Boolean(formik.errors.imie)}
          helperText={formik.touched.imie && formik.errors.imie}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <Input
          label="Nazwisko"
          id="nazwisko"
          name="nazwisko"
          value={formik.values.nazwisko}
          onChange={formik.handleChange}
          error={formik.touched.nazwisko && Boolean(formik.errors.nazwisko)}
          helperText={formik.touched.nazwisko && formik.errors.nazwisko}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <Input
          label="E-mail"
          id="email"
          name="email"
          value={formik.values.email}
          onChange={formik.handleChange}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
        <Input
          label="Telefon"
          id="telefon"
          name="telefon"
          value={formik.values.telefon}
          onChange={formik.handleChange}
          error={formik.touched.telefon && Boolean(formik.errors.telefon)}
          helperText={formik.touched.telefon && formik.errors.telefon}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
        />
      </FormWrapper>
    </BasicFormWrapper>
  );
};

export default OperatorAddForm;

const BasicFormWrapper = styled.form`
  width: 100%;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  // padding: 0 40px;

  @media (${theme.device.laptop}){
    width: 100%;
    // padding: 0 10px;
  }
`;

const FormWrapper = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width:260px;
  max-width:420px;
  gap: 25px;

  @media (${theme.device.laptop}){
    width: 100%;
  }
`;